export default __webpack_public_path__ + "static/media/ContainerPort-Logo-white.b8da87a7.png";